<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <h2>{{ $t("analysis.info") }}</h2>
        <p>{{ meter.description }}</p>
        <p>
          {{ $t("analysis.mounted-location") }}: {{ meter.mounted_location }}
        </p>
        <p>{{ $t("analysis.medium") }}: {{ mediumName }}</p>
        <p>{{ $t("analysis.device-type") }}: {{ meter.device_type }}</p>
        <p>{{ $t("analysis.serial-number") }}: {{ meter.serial_number }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "MeterDetails",
  props: {
    meter: {
      type: Object
    }
  },
  computed: {
    mediumName() {
      if (this.meter._medium && this.meter._medium.id) {
        let medium = this.$store.getters["mediumStore/getList"].find(
          i => i.id === this.meter._medium.id
        );
        return medium && medium.name;
      }
      return "";
    }
  },
  mounted() {
    this.$store.dispatch("mediumStore/getList", {
      params: { limit: -1 }
    });
  }
};
</script>

<style scoped></style>
